import { render, staticRenderFns } from "./RealmCreatorFactions.vue?vue&type=template&id=2e5ecd65"
import script from "./RealmCreatorFactions.vue?vue&type=script&lang=js"
export * from "./RealmCreatorFactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports